class ExternalLink {
  static generate(selector, wrapper = null) {
    window.addEventListener("load", (e) => {
      try {
        wrapper = wrapper || document;
        if (typeof wrapper != "object") {
          wrapper = document.querySelector(wrapper);
        }
        if (wrapper == null) {
          throw new Error(
            "The element for the wrapper you specified cannot be found."
          );
        }
        const list = [...wrapper.querySelectorAll(selector)];

        if (list.length > 0) {
          list.map((_v, i) => {
            if (_v.hostname != window.location.hostname) {
              _v.target = "_blank";
              _v.rel = "noreferrer noopener";
              _v.classList.add("link_blank");
            }
          });
        } else {
          throw new Error(
            "The element of the selector you specified is not found in the wrapper."
          );
        }
      } catch (e) {
        console.error(e);
      }
    });
  }
}
